import { M_SQUARED_TO_KM_SQUARED, maxLssPoints, minLssPointsDensity } from "@/tools/create/lss-from-map/constants";

export const formatMetresSquaredAsKmSquared = (value: number, decimalPlaces = 6) => {
  return `${(value / M_SQUARED_TO_KM_SQUARED).toFixed(decimalPlaces)}km²`;
};

/**
 * Returns the point grid spacing (in metres) for a polygon of the given area (in m²),
 * such that the generated grid never exceeds maxLssPoints.
 *
 * A pointGrid with spacing d over area A produces ~A/d² points.
 * Solving A/d² = maxLssPoints gives d = sqrt(A / maxLssPoints).
 *
 * At 1km² this yields sqrt(1,000,000 / 2500) = 20m. For areas smaller than 1km²,
 * minLssPointsDensity is returned to avoid unnecessarily dense grids.
 */
export const getLssPointsDensity = (areaMSquared: number): number => {
  return Math.max(minLssPointsDensity, Math.sqrt(areaMSquared / maxLssPoints));
};
